import React from "react";
import cn from "classnames";
export default function Section({
  children,
  className,
  variant = "normal",
  id,
}) {
  return (
    <div
      id={id}
      className={cn(
        ` w-full h-auto flex flex-col z-10 relative`,
        {
          "md:py-16 py-10 lg:px-16 md:px-8 px-4": variant === "normal",
          "md:py-16 py-10 md:px-8 px-4": variant === "medium",
          "py-10 lg:px-16 md:px-8 px-4": variant === "flat",
          "py-0 lg:px-16 md:px-8 px-4": variant === "zero",
        },
        className
      )}
    >
      <div className={`w-full flex flex-col`}>{children}</div>
    </div>
  );
}
